<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { ContextConsistencyAnalysisReadModel, PanelistConsistencyAnalysisReadModel } from "@Evaluation/CriteriaSurveys/Domain/readmodels";
    import { numCompare } from "@common/Common";
    import ConsistencyAnalysisLegend from "@Evaluation/Common/Components/ConsistencyAnalysisLegend.vue";
    import ConsistencyAnalysisCircles from "@Evaluation/Common/Components/ConsistencyAnalysisCircles.vue";
    import { ConsistencyAnalysisStatus } from "@Evaluation/Model";

    @Component({
        components: { ConsistencyAnalysisLegend, ConsistencyAnalysisCircles },
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propRm: { type: Object, required: false, default: null },
        }
    })
    export default class PanelistConsistencyAnalysisDialog extends Vue
    {
        get opened(): boolean { return this.$props.propOpened; }
        get rm(): PanelistConsistencyAnalysisReadModel { return this.$props.propRm as PanelistConsistencyAnalysisReadModel; }

        get contexts(): ContextConsistencyAnalysisReadModel[] 
        {
            return this.rm?.Contexts.sort((a, b) => numCompare(a.CR, b.CR)).reverse();
        }

        getCssClass(status: ConsistencyAnalysisStatus): string 
        {
            if (status == ConsistencyAnalysisStatus.Consistent)
            {
                return "bg-success";
            }
            else if (status == ConsistencyAnalysisStatus.Acceptable)
            {
                return "bg-warning";
            }
            else if (status == ConsistencyAnalysisStatus.Inconsistent)
            {
                return "bg-danger";
            }
            else
            {
                return "";
            }
        }

        showQuestion(questionId: string)
        {
            this.$emit('show-question', questionId);
            //this.Close();
        }

        close()
        {
            this.$emit('close-dialog');
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Consistency analysis</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h3 v-if="!rm" class="text-center"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>

                        <div v-if="rm">
                            <h6 class="bg-light p-2 border mb-0">
                                <a class="text-dark" data-toggle="collapse" data-target="#consistencyAnalysisLegend" role="button">
                                    <i class="fa fa-question-circle-o" aria-hidden="true"></i> What is inconsistency score?
                                </a>
                            </h6>
                            <div class="collapse" id="consistencyAnalysisLegend">
                                <ConsistencyAnalysisLegend></ConsistencyAnalysisLegend>
                            </div>

                            <table class="table mt-3">
                                <thead class="thead-light">
                                    <tr>
                                        <th style="width: 50px;"></th>
                                        <th>Context</th>
                                        <th class="px-0">Inconsistency score</th>
                                        <th style="width: 50px;"></th>
                                        <th style="width: 120px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="c in contexts" :key="c.CriterionId">
                                        <td>
                                            <ConsistencyAnalysisCircles :status="c.Status"></ConsistencyAnalysisCircles>
                                        </td>
                                        <td>
                                            <span>{{c.CriterionName}}</span><br />
                                            <small>{{c.CriterionPath}}</small>
                                        </td>
                                        <td class="px-0">
                                            <div v-if="c.CR != null" class="progress" style="height: 30px;">
                                                <div class="progress-bar text-dark" role="progressbar" :class="getCssClass(c.Status)" :style="{'width': c.CR + '%'}"></div>
                                            </div>
                                            <span v-if="c.CR == null" class="font-italic">
                                                Insufficient data
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="c.CR != null">{{c.CR}}%</span>
                                        </td>
                                        <td>
                                            <a class="btn btn-outline-secondary" v-sanitizedHref="c.CriterionUrl">Review</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>